const ProductTypes = {
  swagmagic: "swagmagic",
  snacks: "snacks",
  snacksKit: "snacks_kit",
  dsd: "dsd",
  medley: "medley",
  themedBox: "box",
  giftCard: "gift_card",
  byo: "international_medley",
};

export const { swagmagic, snacks, snacksKit, dsd, medley, themedBox, giftCard, byo } = ProductTypes;

const DEFAULT_COLLECTION_TYPE_FOR_FE = "collection";
export const COLLECTION_PRODUCT_TYPES = [medley, themedBox, DEFAULT_COLLECTION_TYPE_FOR_FE];
export const ITEM_PRODUCT_TYPES = {
  product: "Spree::Product",
  collection: "Spree::ProductSet",
  byo: "byo_items",
};

export const OPTIONTYPE_SIZE_KEY = "size";
export const OPTIONTYPE_COLOR_KEY = "color";
